import { useTranslation } from 'react-i18next';
import { LOCALES } from '../i18n/index.js';
import { useAuth } from '../auth/AuthContext.jsx';

/** Changing the language also persists it on the user profile when logged in. */
const LanguageSwitcher = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const { user, setLocale } = useAuth();

  const current = i18n.resolvedLanguage;

  const onChange = (event) => {
    const next = event.target.value;
    if (user) setLocale(next);
    else i18n.changeLanguage(next);
  };

  return (
    <label className={compact ? 'lang-switcher lang-switcher--compact' : 'lang-switcher'}>
      <span className="sr-only">{t('common.language')}</span>
      <select value={current} onChange={onChange} aria-label={t('common.language')}>
        {LOCALES.map((locale) => (
          <option key={locale.code} value={locale.code}>
            {locale.flag} - {locale.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
